import { render, staticRenderFns } from "./representativeFile.vue?vue&type=template&id=46a990dc&scoped=true"
import script from "./representativeFile.vue?vue&type=script&lang=js"
export * from "./representativeFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a990dc",
  null
  
)

export default component.exports